import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboAtividadeComponent } from './combo-atividade.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboAtividadeComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboAtividadeComponent]
})
export class ComboAtividadeModule { }
